const calcEngineServiceMixin = {
	data: function () {
		return {
			CALCENGINE_BASE: '/api/CalcEngine/',
		};
	},
	methods: {
		getProductPriceApi(productPrice) {
			return this.post(this.CALCENGINE_BASE, 'GetProductPrice', productPrice, true);
		},
		async validateProduct(productPrice) {
			return this.post(this.CALCENGINE_BASE, 'ValidateProduct', productPrice);
		},
		getBasicProductPriceApi: function (product) {
			return this.post(this.CALCENGINE_BASE, 'GetBasicProductPrice', product, true);
		},
		getLetteringProductPriceApi: function (product) {
			return this.post(this.CALCENGINE_BASE, 'GetLetteringPrice', product, true);
		},
	},
};
